import { Tooltip, Typography, TypographyVariant } from "@mui/material";
import { User } from "../../../app/backendTypes";

function UserSpan(props: { user: User; variant?: TypographyVariant }) {
  const { user, variant } = props;

  return (
    <Tooltip arrow placement="top" title={user.employee.name}>
      <Typography
        component="span"
        variant={variant}
        style={{
          fontWeight: "bold",
        }}
      >
        {user.employee.username}
      </Typography>
    </Tooltip>
  );
}

export default UserSpan;
